import axios from "axios";
import router from "../router";
const http = axios.create({
  baseURL: "", //开发调试
  // baseURL: "", //线上环境
  timeout: 180000, //超时时长30s,
});

let loadingInstance = "";
//添加请求拦截器
http.interceptors.request.use(
  (config) => {
    config.url = decodeURI(encodeURI(config.url).replace("%E2%80%8B", "")); //去除url中的空格
    let token = "";
    let user = sessionStorage.getItem("user_info");
    if (user) {
      user = JSON.parse(user);
      token = user.token;
    }
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (err) => {
    //this.$Message.error("请求超时!");
    console.log("请求超时!");
    router.replace("/login");
    loadingInstance.close();
    return Promise.resolve(err);
  }
);

//响应拦截器
http.interceptors.response.use(
  (response) => {
    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data;
    // 这个状态码是和后端约定的
    const { code } = dataAxios;
    // 根据 code 进行判断
    if (code === undefined) {
      // 如果没有 code 代表这不是项目后端开发的接口
      // errorCreate(`请求失败:请求接口不是项目接口 `);
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      if (code === 99) {
        //this.$Message.error(dataAxios.errmsg);
        console.log(dataAxios.errmsg);
        router.replace("/login");
      } else {
        return dataAxios;
      }
    }
  },
  (error) => {
    if (error.response && error.response.status) {
      console.log(error.response.status);
      switch (error.response.status) {
        //401: 未登录-授权过期
        case 401:
          //授权过期时进行的操作,如返回登录页等

          //如有刷新token的需求,可放开以下代码
          //var config=error.config;
          //refreshTokenFuc(isRefreshToken, config, retryRequests);
          break;
      }
      return Promise.reject(error.response);
    }
    return Promise.reject(error);
  }
);

export default http;
